module.exports = __webpack_public_path__ + "img/rectangle-fill-red.fabdfa11.svg";